type CheckboxColor = 'primary' | 'blue' | 'red' | 'green' | 'yellow' | 'purple' | 'pink' | 'indigo';

type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
    label?: React.ReactElement;
    width?: number;
    height?: number;
    color?: CheckboxColor;
};

const Checkbox: React.FC<CheckboxProps> = ({ label, width = 20, height, color = 'primary', ...props }) => {
    const finalHeight = height ?? width;
    const iconScale = Math.min(width, finalHeight) / 20;

    const colorClasses = {
        primary: 'checked:border-primary-500 checked:bg-primary-500',
        blue: 'checked:border-blue-500 checked:bg-blue-500',
        red: 'checked:border-red-500 checked:bg-red-500',
        green: 'checked:border-green-500 checked:bg-green-500',
        yellow: 'checked:border-yellow-500 checked:bg-yellow-500',
        purple: 'checked:border-purple-500 checked:bg-purple-500',
        pink: 'checked:border-pink-500 checked:bg-pink-500',
        indigo: 'checked:border-indigo-500 checked:bg-indigo-500'
    };

    return (
        <label className='inline-flex cursor-pointer items-center gap-2 select-none'>
            <div className='relative flex items-center'>
                <input
                    type='checkbox'
                    className={`peer cursor-pointer appearance-none rounded border border-gray-300 bg-white transition-all ${colorClasses[color]}`}
                    style={{
                        width: `${width}px`,
                        height: `${finalHeight}px`
                    }}
                    {...props}
                />
                <span className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform text-white opacity-0 peer-checked:opacity-100'>
                    <svg
                        width={14 * iconScale}
                        height={10 * iconScale}
                        viewBox='0 0 14 10'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M12.3332 1L4.99984 8.33333L1.6665 5'
                            stroke='white'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                </span>
            </div>
            {label && label}
        </label>
    );
};

export default Checkbox;

